import React, { useEffect, useState } from 'react';
import { MenuItem, Select, ListSubheader } from '@mui/material';

import { PaymentMethod } from 'types/Billing';
import { PaymentMethodType, OnFormIsValidType, OnFormIsValid } from './interfaces';
import PaymentMethodItem from './PaymentMethodItem';

const STRIPE_BANK_ACCOUNT = 'bank_account';
const STRIPE_CARD = 'payment_method';

interface Props {
  paymentList: PaymentMethod[];
  defaultPaymentMethod?: PaymentMethod;
  onFormIsValid: OnFormIsValid;
}

const SavedPaymentMethods: React.FC<Props> = ({
  paymentList,
  defaultPaymentMethod,
  onFormIsValid,
}) => {
  const defaultPayment = defaultPaymentMethod || (paymentList.length > 0 ? paymentList[0] : null);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(defaultPayment);
  const bankAccounts = paymentList.filter((pm) => pm.object === STRIPE_BANK_ACCOUNT);
  const cards = paymentList.filter((pm) => pm.object === STRIPE_CARD);

  useEffect(() => {
    if (selectedPaymentMethod) {
      onFormIsValid(true, {
        type: OnFormIsValidType.SAVED_PAYMENT_METHOD,
        paymentType:
          selectedPaymentMethod.object === STRIPE_BANK_ACCOUNT
            ? PaymentMethodType.BANK_ACCOUNT
            : PaymentMethodType.CARD,
        paymentMethodId: selectedPaymentMethod.id,
      });
    }
  }, [selectedPaymentMethod, onFormIsValid]);
  return (
    <Select
      variant="outlined"
      displayEmpty
      disabled={paymentList.length === 0}
      sx={{
        '& .MuiSelect-select': {
          padding: 0,
        },
      }}
      className="w-full"
      renderValue={(value) => (
        <PaymentMethodItem
          value={value}
          isDefault={
            defaultPaymentMethod && typeof value === 'object'
              ? defaultPaymentMethod.id === value.id
              : false
          }
        />
      )}
      value={selectedPaymentMethod || ''}
      onChange={(e) => setSelectedPaymentMethod(e.target.value as PaymentMethod)}
    >
      {bankAccounts.length > 0 && (
        <ListSubheader style={{ lineHeight: '2rem' }}>Bank Accounts</ListSubheader>
      )}
      {bankAccounts.map((pm) => (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        <MenuItem className="w-full" sx={{ padding: 0 }} key={pm.id} value={pm}>
          <PaymentMethodItem
            value={pm}
            isDefault={
              defaultPaymentMethod && typeof pm === 'object'
                ? defaultPaymentMethod.id === pm.id
                : false
            }
          />
        </MenuItem>
      ))}
      {cards.length > 0 && <ListSubheader style={{ lineHeight: '2rem' }}>Cards</ListSubheader>}
      {cards.map((pm) => (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        <MenuItem className="w-full" style={{ padding: 0 }} key={pm.id} value={pm}>
          <PaymentMethodItem
            value={pm}
            isDefault={
              defaultPaymentMethod && typeof pm === 'object'
                ? defaultPaymentMethod.id === pm.id
                : false
            }
          />
        </MenuItem>
      ))}
    </Select>
  );
};

export default SavedPaymentMethods;
